export default __webpack_public_path__ + "static/media/360blog.28ca5f1f.png";